module.exports = __webpack_public_path__ + "assets/img/20-double-eleven_float.16477fde.png";